export const actions = {
  SET_LAYOUT: 'SET_LAYOUT',
  SET_TITLE: 'SET_TITLE',
  SET_BREAD_CRUMBS: 'SET_BREAD_CRUMBS',
  SET_BACK_ADDRESS: 'SET_BACK_ADDRESS',
};

export default actions;
